import { t } from 'i18next';

export const GENERIC_ERROR_MESSAGE = t(
  'add_wallet_modal.api_key_form.generic_error_message',
);
